import { render, staticRenderFns } from "./PdfTemplateFieldTable.vue?vue&type=template&id=b92e114a&scoped=true&"
import script from "./PdfTemplateFieldTable.vue?vue&type=script&lang=ts&"
export * from "./PdfTemplateFieldTable.vue?vue&type=script&lang=ts&"
import style0 from "./PdfTemplateFieldTable.vue?vue&type=style&index=0&id=b92e114a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92e114a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VIcon,VSimpleTable})
